module.exports = __webpack_public_path__ + "img/battery_alert.789dccb9.svg";